var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"text-sm",class:_setup.state.color},[_vm._v(" "+_vm._s(_setup.state.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }